import React from 'react'
import { Box, Button, Chip, Paper, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { router, usePage } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

Show.layout = (page) => <AppShell>{page}</AppShell>

export default function Show({ property, cost_category }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  const handleDelete = () => {
    if (window.confirm('Kostenkategorie wirklich löschen?')) {
      router.delete(`${basePath}/cost_categories/${cost_category.id}`)
    }
  }

  return (
    <Box>
      <PageHeader
        title={cost_category.name}
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Kostenkategorien', href: `${basePath}/cost_categories` },
          { label: cost_category.name },
        ]}
        actions={
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button variant="outlined" size="small" startIcon={<EditIcon />}
              onClick={() => router.visit(`${basePath}/cost_categories/${cost_category.id}/edit`)}
              data-testid="edit-btn">
              Bearbeiten
            </Button>
            <Button variant="outlined" size="small" color="error" startIcon={<DeleteIcon />}
              onClick={handleDelete} data-testid="delete-btn">
              Löschen
            </Button>
          </Box>
        }
      />

      <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider', maxWidth: 600 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box>
            <Typography variant="caption" color="text.secondary">Name</Typography>
            <Typography component="div">
              {cost_category.name}
              {cost_category.system && (
                <Chip size="small" label="System" color="info" variant="outlined" sx={{ ml: 1 }} />
              )}
            </Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">Slug</Typography>
            <Typography><code>{cost_category.slug}</code></Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">Gruppe</Typography>
            <Typography>{cost_category.group || '–'}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">Verteilschlüssel</Typography>
            <Typography>{cost_category.distribution_key_name || '–'}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">Umlagefähig</Typography>
            <Typography>{cost_category.allocatable ? 'Ja' : 'Nein'}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">Heizungskosten</Typography>
            <Typography>{cost_category.heating_related ? 'Ja' : 'Nein'}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">Position</Typography>
            <Typography>{cost_category.position || '–'}</Typography>
          </Box>
          {cost_category.default_distribution_key && (
            <Box>
              <Typography variant="caption" color="text.secondary">Standard-Verteilerschlüssel (System)</Typography>
              <Typography>{cost_category.default_distribution_key}</Typography>
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  )
}
